export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id|| "Id No disponible",
    barrio_descripcion: item.barrio_descripcion || "Descripción no disponible", // Descripción con valor por defecto
    localidad: item.loc_barrio?.loc_descripcion || "No se encuentra provincia", // Uso del operador optional chaining 
  }));
